import { getServerEnv, isLocal, isServer } from './env-helper';

const devDebugStorageKeys = {
  segment: 'flipster.dev.segment_console_debug',
  datadog: 'flipster.dev.datadog_console_debug',
  websocket: 'flipster.dev.websocket_console_debug',
} as const;

type DevDebugFlag = keyof typeof devDebugStorageKeys;

function isDevDebugAvailable(): boolean {
  if (isServer) return false;
  // Vitest 등 window.location.hostname 이 없는 환경에서는 dev debug 비활성
  if (!window.location?.hostname) return false;
  if (isLocal()) return true;
  return getServerEnv() !== 'prod';
}

function isDevDebugEnabled(flag: DevDebugFlag): boolean {
  if (!isDevDebugAvailable()) return false;
  try {
    return localStorage.getItem(devDebugStorageKeys[flag]) === 'true';
  } catch {
    return false;
  }
}

function setDevDebugEnabled(flag: DevDebugFlag, enabled: boolean): void {
  if (!isDevDebugAvailable()) return;
  try {
    localStorage.setItem(devDebugStorageKeys[flag], String(enabled));
  } catch {
    // quota exceeded 등 localStorage 접근 실패 시 무시
  }
}

export function isSegmentConsoleDebugEnabled(): boolean {
  return isDevDebugEnabled('segment');
}

export function setSegmentConsoleDebugEnabled(enabled: boolean): void {
  setDevDebugEnabled('segment', enabled);
}

export function shouldLogSegmentToConsole(): boolean {
  return isSegmentConsoleDebugEnabled();
}

export function isDatadogConsoleDebugEnabled(): boolean {
  return isDevDebugEnabled('datadog');
}

export function setDatadogConsoleDebugEnabled(enabled: boolean): void {
  setDevDebugEnabled('datadog', enabled);
}

export function shouldLogDatadogToConsole(): boolean {
  return isDatadogConsoleDebugEnabled();
}

export function isWebsocketConsoleDebugEnabled(): boolean {
  return isDevDebugEnabled('websocket');
}

export function setWebsocketConsoleDebugEnabled(enabled: boolean): void {
  setDevDebugEnabled('websocket', enabled);
}

export function shouldLogWebsocketToConsole(): boolean {
  return isWebsocketConsoleDebugEnabled();
}
